export default "__VITE_ASSET__CU8P$ZOu__"